import {
  ON_FILTER_CONSIGNER_OPTION_SELECT,
  FETCH_UNPUBLISHED_MERCHANDISE_ITEMS,
  FETCH_UNPUBLISHED_MERCHANDISE_ITEMS_SUCCESS,
  FETCH_PUBLISHED_MERCHANDISE_ITEMS,
  FETCH_PUBLISHED_MERCHANDISE_ITEMS_SUCCESS,
  FETCH_MERCHANDISE_ITEMS_TO_REVIEW,
  FETCH_MERCHANDISE_ITEMS_TO_REVIEW_SUCCESS,
  FETCH_CONSIGNER_OPTIONS,
  FETCH_CONSIGNER_OPTIONS_SUCCESS,
  BEGIN_MERCHANDISE_REVIEW,
  BEGIN_MERCHANDISE_REVIEW_SUCCESS,
  CANCEL_MERCHANDISE_REVIEW,
  CANCEL_MERCHANDISE_REVIEW_SUCCESS,
  FETCH_MERCHANDISE_ITEM,
  FETCH_MERCHANDISE_ITEM_SUCCESS,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  SEARCH_MERCHANDISE_PRODUCTS,
  SEARCH_MERCHANDISE_PRODUCTS_SUCCESS,
  MATCH_MERCHANDISE_TO_PRODUCT,
  MATCH_MERCHANDISE_TO_PRODUCT_SUCCESS,
  ON_REVIEW_ITEM_CONDITION_GRADE_SELECT,
  PUBLISH_MERCHANDISE_ITEM,
  PUBLISH_MERCHANDISE_ITEM_SUCCESS,
  MAKE_MERCHANDISE_DECISION,
  MAKE_MERCHANDISE_DECISION_SUCCESS,
  SHOW_MERCHANDISE_DETAILS,
  SHOW_MERCHANDISE_DETAILS_SUCCESS,
  SHOW_PRODUCT_ITEM,
  SAVE_PRODUCT_ITEM,
  SAVE_PRODUCT_ITEM_SUCCESS,
  SAVE_PRODUCT_CHANNEL_INFO,
  SAVE_PRODUCT_CHANNEL_INFO_SUCCESS,
  SAVE_PRODUCT_CHANNEL_INFO_ERROR,
  SAVE_ITEM_CHANNEL_INFO,
  SAVE_ITEM_CHANNEL_INFO_SUCCESS,
  SAVE_ITEM_CHANNEL_INFO_ERROR,
  FETCH_ITEM_CHANNEL_INFO,
  FETCH_ITEM_CHANNEL_INFO_ERROR,
  FETCH_ITEM_CHANNEL_INFO_SUCCESS,
  FETCH_ITEM_NOTES,
  FETCH_ITEM_NOTES_ERROR,
  FETCH_ITEM_NOTES_SUCCESS,
  CREATE_ITEM_NOTES,
  CREATE_ITEM_NOTES_ERROR,
  CREATE_ITEM_NOTES_SUCCESS,
  CLEAR_ITEM_NOTES,
  RESET_CHANNEL_INFO,
  UPDATE_MERCHANDISE_FILTER_OPTIONS,
  FETCH_DONATE_MERCHANDISE_ITEMS,
  FETCH_DONATE_MERCHANDISE_ITEMS_SUCCESS,
  FETCH_DONATE_MERCHANDISE_ITEMS_ERROR,
  SAVE_PRODUCT_ITEM_ERROR,
} from "../constants/ActionTypes";

export const onFilterConsignerOptionSelect = (option) => {
  return {
    type: ON_FILTER_CONSIGNER_OPTION_SELECT,
    payload: option,
  };
};
export const fetchUnpublishedMerchandiseItems = (data) => {
  return {
    type: FETCH_UNPUBLISHED_MERCHANDISE_ITEMS,
    payload: data,
  };
};
export const fetchUnpublishedMerchandiseItemsSuccess = (entities) => {
  return {
    type: FETCH_UNPUBLISHED_MERCHANDISE_ITEMS_SUCCESS,
    payload: entities,
  };
};
export const fetchPublishedMerchandiseItems = (data) => {
  return {
    type: FETCH_PUBLISHED_MERCHANDISE_ITEMS,
    payload: data,
  };
};
export const fetchPublishedMerchandiseItemsSuccess = (entities) => {
  return {
    type: FETCH_PUBLISHED_MERCHANDISE_ITEMS_SUCCESS,
    payload: entities,
  };
};
export const fetchDonateMerchandiseItems = (data) => {
  return {
    type: FETCH_DONATE_MERCHANDISE_ITEMS,
    payload: data,
  };
};
export const fetchDonateMerchandiseItemsSuccess = (entities) => {
  return {
    type: FETCH_DONATE_MERCHANDISE_ITEMS_SUCCESS,
    payload: entities,
  };
};
export const fetchDonateMerchandiseItemsError = (data) => {
  return {
    type: FETCH_DONATE_MERCHANDISE_ITEMS_ERROR,
    payload: data,
  };
};
export const fetchMerchandiseItemsToReview = (data) => {
  return {
    type: FETCH_MERCHANDISE_ITEMS_TO_REVIEW,
    payload: data,
  };
};
export const fetchMerchandiseItemsToReviewSuccess = (entities) => {
  return {
    type: FETCH_MERCHANDISE_ITEMS_TO_REVIEW_SUCCESS,
    payload: entities,
  };
};
export const fetchConsignerOptions = () => {
  return {
    type: FETCH_CONSIGNER_OPTIONS,
  };
};
export const fetchConsignerOptionsSuccess = (entities) => {
  return {
    type: FETCH_CONSIGNER_OPTIONS_SUCCESS,
    payload: entities,
  };
};
export const beginMerchandiseReview = (data) => {
  return {
    type: BEGIN_MERCHANDISE_REVIEW,
    payload: data,
  };
};
export const beginMerchandiseReviewSuccess = (entity) => {
  return {
    type: BEGIN_MERCHANDISE_REVIEW_SUCCESS,
    payload: entity,
  };
};
export const cancelMerchandiseReview = (data) => {
  return {
    type: CANCEL_MERCHANDISE_REVIEW,
    payload: data,
  };
};
export const cancelMerchandiseReviewSuccess = (item) => {
  return {
    type: CANCEL_MERCHANDISE_REVIEW_SUCCESS,
    payload: item,
  };
};
export const fetchMerchandiseItem = (id) => {
  return {
    type: FETCH_MERCHANDISE_ITEM,
    payload: id,
  };
};
export const fetchMerchandiseItemSuccess = (item) => {
  return {
    type: FETCH_MERCHANDISE_ITEM_SUCCESS,
    payload: item,
  };
};
export const searchMerchandiseProducts = (data) => {
  return {
    type: SEARCH_MERCHANDISE_PRODUCTS,
    payload: data,
  };
};
export const searchMerchandiseProductsSuccess = (entities) => {
  return {
    type: SEARCH_MERCHANDISE_PRODUCTS_SUCCESS,
    payload: entities,
  };
};
export const matchMerchandiseItemToProduct = (data) => {
  return {
    type: MATCH_MERCHANDISE_TO_PRODUCT,
    payload: data,
  };
};
export const matchMerchandiseItemToProductSuccess = (item) => {
  return {
    type: MATCH_MERCHANDISE_TO_PRODUCT_SUCCESS,
    payload: item,
  };
};
export const onReviewItemConditionGradeSelect = (option) => {
  return {
    type: ON_REVIEW_ITEM_CONDITION_GRADE_SELECT,
    payload: option,
  };
};
export const publishMerchandiseItem = (data) => {
  return {
    type: PUBLISH_MERCHANDISE_ITEM,
    payload: data,
  };
};
export const publishMerchandiseItemSuccess = (data) => {
  return {
    type: PUBLISH_MERCHANDISE_ITEM_SUCCESS,
    payload: data,
  };
};
export const makeMerchandiseItemDecision = (data) => {
  return {
    type: MAKE_MERCHANDISE_DECISION,
    payload: data,
  };
};
export const makeMerchandiseItemDecisionSuccess = (data) => {
  return {
    type: MAKE_MERCHANDISE_DECISION_SUCCESS,
    payload: data,
  };
};
export const showMerchandiseDetails = (data) => {
  return {
    type: SHOW_MERCHANDISE_DETAILS,
    payload: data,
  };
};
export const showMerchandiseDetailsSuccess = (data) => {
  return {
    type: SHOW_MERCHANDISE_DETAILS_SUCCESS,
    payload: data,
  };
};
export const showProductItem = (data) => {
  return {
    type: SHOW_PRODUCT_ITEM,
    payload: data,
  };
};
export const saveProductItem = (data) => {
  return {
    type: SAVE_PRODUCT_ITEM,
    payload: data,
  };
};
export const saveProductItemSuccess = (data) => {
  return {
    type: SAVE_PRODUCT_ITEM_SUCCESS,
    payload: data,
  };
};
export const saveProductItemError = (data) => {
  return {
    type: SAVE_PRODUCT_ITEM_ERROR,
    payload: data,
  };
};
export const saveProductChannelInfo = (data) => {
  return {
    type: SAVE_PRODUCT_CHANNEL_INFO,
    payload: data,
  };
};
export const saveProductChannelInfoSuccess = (data) => {
  return {
    type: SAVE_PRODUCT_CHANNEL_INFO_SUCCESS,
    payload: data,
  };
};
export const saveProductChannelInfoError = (data) => {
  return {
    type: SAVE_PRODUCT_CHANNEL_INFO_ERROR,
    payload: data,
  };
};
export const saveItemChannelInfo = (data) => {
  return {
    type: SAVE_ITEM_CHANNEL_INFO,
    payload: data,
  };
};
export const saveItemChannelInfoSuccess = (data) => {
  return {
    type: SAVE_ITEM_CHANNEL_INFO_SUCCESS,
    payload: data,
  };
};
export const saveItemChannelInfoError = (data) => {
  return {
    type: SAVE_ITEM_CHANNEL_INFO_ERROR,
    payload: data,
  };
};
export const fetchItemChannelInfo = (data) => {
  return {
    type: FETCH_ITEM_CHANNEL_INFO,
    payload: data,
  };
};
export const fetchItemChannelInfoSuccess = (data) => {
  return {
    type: FETCH_ITEM_CHANNEL_INFO_SUCCESS,
    payload: data,
  };
};
export const fetchItemChannelInfoError = (data) => {
  return {
    type: FETCH_ITEM_CHANNEL_INFO_ERROR,
    payload: data,
  };
};
export const resetChannelInfo = () => {
  return {
    type: RESET_CHANNEL_INFO,
  };
};

export const showMerchandiseLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};
export const hideMerchandiseLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
export const updateMerchandiseFilterOptions = (updates) => {
  return {
    type: UPDATE_MERCHANDISE_FILTER_OPTIONS,
    payload: updates,
  };
};
export const fetchItemNotes = (data) => {
  return {
    type: FETCH_ITEM_NOTES,
    payload: data,
  };
};
export const fetchItemNotesSuccess = (data) => {
  return {
    type: FETCH_ITEM_NOTES_SUCCESS,
    payload: data,
  };
};
export const fetchItemNotesError = (data) => {
  return {
    type: FETCH_ITEM_NOTES_ERROR,
    payload: data,
  };
};
export const clearItemNotes = () => {
  return {
    type: CLEAR_ITEM_NOTES,
  };
};
export const createItemNotes = (data) => {
  return {
    type: CREATE_ITEM_NOTES,
    payload: data,
  };
};
export const createItemNotesSuccess = (data) => {
  return {
    type: CREATE_ITEM_NOTES_SUCCESS,
    payload: data,
  };
};
export const createItemNotesError = (data) => {
  return {
    type: CREATE_ITEM_NOTES_ERROR,
    payload: data,
  };
};
